import styled from 'styled-components';
import InfoHint from '../../info-hint/info-hint-view';

export const StyledLink = styled.a<{ color?: string }>`
  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.black)};
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const StyledInfoHint = styled(InfoHint)`
  margin-top: 20px;
  max-width: 800px;
`;
